import { CheckboxOption } from '@uc/web/shared/data-models';
import {
	EventsFilterApiResponse,
	EventsFilterOptions,
	EventsSearchPayload,
	EventsSearchFilterKey,
} from '../models/open-days.models';
import { isObjectEmpty } from '@uc/utilities';

/**
 * @param filters from store location and uniTypes selected by user
 * @param payload from store
 * @returns filter options with checked values based on what IDs have been sent to the BE & stored in the payload
 */
export const setCheckedValueForFilters = (
	filters: EventsFilterOptions,
	payload: EventsSearchPayload,
): EventsFilterOptions => {
	const filtersCopy = { ...filters };

	for (const property in filtersCopy) {
		const key = property as EventsSearchFilterKey;
		if (['locations', 'types'].includes(key)) {
			const options = filtersCopy[key];
			const payloadKey = getPayloadKey(key);

			if (payloadKey && payload[payloadKey]) {
				const selectedOptionIds = new Set(payload[payloadKey]);
				options.forEach((option) => {
					option.checked = selectedOptionIds.has(option.id);
				});
			}
		}
	}

	return filtersCopy;
};

// Updates the count of events for each filter option. Used to update store.filters.
export const updateFiltersCount = (
	filters: EventsFilterOptions,
	filterApiResponse: EventsFilterApiResponse[],
): EventsFilterOptions => {
	if (
		!filters ||
		!filterApiResponse ||
		isObjectEmpty(filters) ||
		isObjectEmpty(filterApiResponse)
	)
		return filters;

	const updateCount = (checkboxArray: CheckboxOption[], values: any[]) => {
		return checkboxArray.map((option) => {
			const matchedFilter = values.find((val) => val.id === option.id);
			return matchedFilter
				? { ...option, count: matchedFilter.count }
				: { ...option, count: 0 };
		});
	};

	const updatedFilters = { ...filters };

	filterApiResponse.forEach((filter) => {
		if (filter.name === 'locations') {
			updatedFilters.locations = updateCount(filters.locations, filter.values);
		} else if (filter.name === 'types') {
			updatedFilters.types = updateCount(filters.types, filter.values);
		}
	});

	return updatedFilters;
};

const getPayloadKey = (filterKey: EventsSearchFilterKey) => {
	switch (filterKey) {
		case 'locations':
			return 'locationIds';
		case 'types':
			return 'typeIds';
	}
};
